<top-bar [field]="field" [isLoadingField]="isLoadingField" [userProfile]="userProfile" [errorField]="errorGetField"></top-bar>

<div class="main-container rr-container-color container-fluid" style="min-height: 95vh;">
  <app-nav-view-datasheet [activeLink]="'tank-gauges'"></app-nav-view-datasheet>

  <p class="text-center mt-4">🚧 <em>We're currently working on this page. Please check again later!</em></p>

  <!--<div class="row px-4" style="padding-bottom: 100px; overflow: hidden">
    <div class="table-responsive rr-elevation-z2 mt-3" style="background-color: white;">
  <table class="table table-hover rr-table text-center">
    <thead class="rr-table-header">-->
  <!--<tr *ngIf="isLoading; else layoutLoaded" class="ignore-hover">
    <td colspan="12">
      <app-loading-indicator></app-loading-indicator>
    </td>
  </tr>-->
  <!--<ng-template #layoutLoaded>-->
  <!--<tr>
    <th>Tank Name</th>
    <th>Opening Stock</th>
    <th>Oil ft</th>
    <th>Oil inch</th>
    <th>Tank Stock</th>
    <th>Water ft</th>
    <th>Water inch</th>
    <th>Water Volume</th>
    <th>Hauled Off Water</th>
    <th>Comments</th>
  </tr>-->
  <!--</ng-template>-->
  <!--</thead>
      <tbody>
        <tr>
          <td>246935 (400 BBL Oil Tank)</td>
          <td>27.71</td>
          <td>10:50 AM</td>
          <td>10</td>
          <td>1.25</td>
          <td>202.49</td>
          <td></td>
          <td></td>
          <td></td>
          <td>This is a test</td>
        </tr>
        <tr>
          <td>246936 (400 BLL Oil Tank)</td>
          <td>140.28</td>
          <td>10:50 AM</td>
          <td></td>
          <td></td>
          <td>0.00</td>
          <td></td>
          <td></td>
          <td></td>
          <td>Hard coded data</td>
        </tr>
      </tbody>
    </table>
    </div>
  </div>-->
</div>
